import mainReducer from './mainReducer';
import appReducer from './appReducer';


export default {
  main: mainReducer,
  app: appReducer,
};